<footer class="site-footer">
  <section class="container">
      <p>Copyright © {{ currentYear }} IBMicommunity. All Rights Reserved</p>
  </section>
</footer>
